import React from 'react';
import styles from './Agreements.module.css';
import { FaDownload } from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

const Agreements = ({agreementsData, handleChange, errors }) => {
  const agreementItems = [
    { name: 'termsOfUse', label: 'Terms of Use', fileName: 'GIFFEN-GENERAL-TERMS-OF-USE.pdf'},
    { name: 'businessAssociate', label: 'Business Associate', fileName: 'GIFFEN-BUSINESS-ASSOCIATE-AGREEMENT.pdf'},
    { name: 'userAgreement', label: 'User Agreement', fileName: 'GIFFEN-END-USER-AGREEMENT.pdf'},
    { name: 'servicesAgreement', label: 'Services Agreement', fileName: 'GIFFEN-SERVICES-AGREEMENT.pdf'},
    { name: 'privacyPolicy', label: 'Privacy Policy', fileName: 'privacy_policy.pdf'},
  ];

  return (
    <>
      <h2 className={styles.stepTitle}>Agreements/Terms and Conditions</h2>
      <p className={styles.stepSubtext}>
        Please review the following documents, check the box next to each, and enter your name to agree.
      </p>
      <div className={styles.formContent}>
        <div className={styles.checkboxGroup}>
          {agreementItems.map((item) => (
            <div key={item.name}>
              <div className={styles.agreementItem}>
                <label className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    name={item.name}
                    checked={agreementsData[item.name]}
                    onChange={handleChange}
                  />
                  <span className={styles.checkboxText}>{item.label}</span>
                </label>
                <div className={styles.linkContainer}>
                  <a
                    href={`/documents/${item.fileName}`}
                    download
                    className={styles.downloadLink}
                    aria-label={`Download ${item.label}`}
                  >
                    <FaDownload className={styles.downloadIcon} />
                  </a>
                  <a
                    href={`/documents/${item.fileName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.openLink}
                    aria-label={`Open ${item.label} in a new tab`}
                  >
                    <FontAwesomeIcon icon={faUpRightFromSquare} />
                  </a>
                </div>
              </div>
              {errors[item.name] && <div className={styles.errorMessage}>{errors[item.name]}</div>}
            </div>
          ))}
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="name">
            By entering your name below, you confirm that you have authorization from your organization to and do agree to the Terms of Use, Business Associate Agreement, User Agreement, and Privacy Policy.
          </label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter Your Name"
            value={agreementsData.name}
            onChange={handleChange}
          />
          {errors.name && <div className={styles.errorMessage}>{errors.name}</div>}
        </div>
      </div>
    </>
  );
};

export default Agreements;